import { objectValues } from '@hsp/utilities';

import { IListPerformance } from '@t/api/bluebook/client-return/list-performance.model';
import { IListManager } from '@t/api/list-performance/list-manager.model';
import { IListName } from '@t/api/list-performance/list-name.model';
import { IListOwner } from '@t/api/list-performance/list-owner.model';
import { ListPerformanceParameters } from '@t/api/list-performance/list-performance-parameters.model';
import { IListSegment } from '@t/api/list-performance/list-segment.model';

import { Uri } from 'constants/index';
import { IResult } from 'types/api/common';

import { BaseHttpService } from './http/base-http.service';

class ListPerformanceService extends BaseHttpService {
  constructor() {
    super({ endpoints: objectValues(Uri.Client) as string[] });
  }

  getListNames(clients?: string[], listManagerId?: string, cancel = false): Promise<IResult<IListName[]>> | undefined {
    const url = Uri.ListPerformance.Names;

    return this.get({
      params: { clients, listManagerId },
      signal: cancel ? this.cancellations[url].onCancellation().signal : undefined,
      url,
      withCredentials: true,
    });
  }

  getListPerformance(
    parameters: ListPerformanceParameters,
    cancel = false
  ): Promise<IResult<IListPerformance[]>> | undefined {
    const url = Uri.ListPerformance.ListPerformance;
    const {
      clientAcronym,
      endDate,
      startDate,
      filter,
      id,
      listCode,
      listOwner,
      managerCode,
      page,
      pageSize,
      segment,
      sort,
    } = parameters;

    return this.get({
      params: {
        clientAcronym: clientAcronym?.join(','),
        endDate,
        filter,
        id,
        listCode,
        listOwner,
        managerCode,
        page: page ?? 1,
        pageSize: pageSize ?? 10,
        segment,
        sort,
        startDate,
      },
      signal: cancel ? this.cancellations[url].onCancellation().signal : undefined,
      url,
      withCredentials: true,
    });
  }

  getManagers(clients?: string[], cancel = false): Promise<IResult<IListManager[]>> | undefined {
    const url = Uri.ListPerformance.Managers;

    return this.get({
      params: { clients },
      signal: cancel ? this.cancellations[url].onCancellation().signal : undefined,
      url,
      withCredentials: true,
    });
  }

  getOwners(clients?: string[], cancel = false): Promise<IResult<IListOwner[]>> | undefined {
    const url = Uri.ListPerformance.Owners;

    return this.get({
      params: { clients },
      signal: cancel ? this.cancellations[url].onCancellation().signal : undefined,
      url,
      withCredentials: true,
    });
  }

  getSegments(listCode?: string, clients?: string[], cancel = false): Promise<IResult<IListSegment[]>> | undefined {
    const url = Uri.ListPerformance.Segments;

    return this.get({
      params: { clients, listCode },
      signal: cancel ? this.cancellations[url].onCancellation().signal : undefined,
      url,
      withCredentials: true,
    });
  }
}

export const listPerformanceService = new ListPerformanceService();
